import {StyledServiceOrderDrawerOrderInfo} from "../../styles";
import {ServiceOrderWorkDeliveryDeliverWorkForm} from "./form";
import {ServiceOrderWorkDeliveryDeliverWorkFormHelper} from "./what-happens-next";

export function ServiceOrderWorkDeliveryDeliverWork() {
  return (
    <StyledServiceOrderDrawerOrderInfo>
      <ServiceOrderWorkDeliveryDeliverWorkForm />
      <ServiceOrderWorkDeliveryDeliverWorkFormHelper />
    </StyledServiceOrderDrawerOrderInfo>
  );
}
